import React from 'react';
import { render } from 'react-dom';
import { App } from './app/app.component';

render(<App />, document.getElementById('app-slot'));
